export default __webpack_public_path__ + "static/media/DSCN0368.704419b0.JPG";